import { PropertyHelper } from '@/helpers/property.helper';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { RealProperty } from '@eemo/api-client';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';

export class QRCodeDialogData {
  prop: RealProperty;
}

@Component({
    selector: 'app-qrcode-dialog',
    templateUrl: './qrcode-dialog.component.html',
    styleUrls: ['./qrcode-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatIconModule]
})
export class QRCodeDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: QRCodeDialogData,
    public dialogRef: MatDialogRef<QRCodeDialogComponent>,
    public propHelper: PropertyHelper
  ) {}

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
